import { render, staticRenderFns } from "./MoleculeEditionProductSatellitesIncludedSubMenu.vue?vue&type=template&id=e87bd8a4&"
import script from "./MoleculeEditionProductSatellitesIncludedSubMenu.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductSatellitesIncludedSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports